// extracted by mini-css-extract-plugin
export default {"trigger":"QMAE8","skeleton-progress":"j6eZa"};